var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteCar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/car",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Car"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1538462,12.5295013 L23.4699915,6.93017751 C23.0845309,5.65207101 21.9281488,4.8 20.6094675,4.8 L9.34995773,4.8 C8.01098901,4.8 6.85460693,5.65207101 6.48943364,6.93017751 L4.80557904,12.5295013 C3.75063398,12.9961116 3,14.0510566 3,15.2683009 L3,21.2530854 C3,22.084869 3.66948436,22.7543533 4.50126796,22.7543533 L4.50126796,22.7543533 L4.50126796,24.2556213 C4.50126796,25.0874049 5.17075232,25.7568893 6.00253593,25.7568893 L7.50380389,25.7568893 C8.33558749,25.7568893 9.00507185,25.0874049 9.00507185,24.2556213 L9.00507185,22.7543533 L20.9949281,22.7543533 L20.9949281,24.2556213 C20.9949281,25.0874049 21.6644125,25.7568893 22.4961961,25.7568893 L23.9974641,25.7568893 C24.8292477,25.7568893 25.498732,25.0874049 25.498732,24.2556213 L25.498732,22.7543533 L25.498732,22.7543533 L25.498732,22.7543533 C26.3305156,22.7543533 27,22.084869 27,21.2530854 L27,15.2683009 C26.9594252,14.0307692 26.2087912,12.9758242 25.1538462,12.5295013 L25.1538462,12.5295013 Z M9.34995773,7.78224852 L20.6094675,7.78224852 L21.9484362,12.2860524 L7.99070161,12.2860524 L9.34995773,7.78224852 L9.34995773,7.78224852 Z M8.98478445,19.0214708 C8.15300085,19.0214708 7.48351648,18.3519865 7.48351648,17.5202029 C7.48351648,16.6884193 8.15300085,16.0189349 8.98478445,16.0189349 C9.81656805,16.0189349 10.4860524,16.6884193 10.4860524,17.5202029 C10.4860524,18.3519865 9.81656805,19.0214708 8.98478445,19.0214708 Z M20.9746407,19.0214708 C20.1428571,19.0214708 19.4733728,18.3519865 19.4733728,17.5202029 C19.4733728,16.6884193 20.1428571,16.0189349 20.9746407,16.0189349 C21.8064243,16.0189349 22.4759087,16.6884193 22.4759087,17.5202029 C22.4556213,18.3519865 21.7861369,19.0214708 20.9746407,19.0214708 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-car.65438f483fa5c31cb57549ad0c4ac25c.svg";